import React from "react"
import { Briefcase, MapPin, Calendar, Check } from "lucide-react"
import BTCConverter from "../../BTCConverter"
import { formatJobDate, formatJobLocation, valueOrFallback } from "./jobDisplay"

export const JobCard = ({ job, onClick, hasApplied }) => {
  return (
    <button
      type="button"
      className="tyk-card relative flex min-h-[360px] w-full cursor-pointer flex-col p-5 text-left"
      onClick={onClick}
    >
      {hasApplied && (
        <div
          className="absolute right-4 top-4 rounded-full border border-green-300/40 bg-green-400/20 p-1 text-green-100"
          title="You have applied to this job"
        >
          <Check size={16} />
        </div>
      )}
      <div className="pr-8">
        <span className="tyk-pill mb-3">
          <Briefcase size={14} aria-hidden="true" />
          {valueOrFallback(job.employmentType)}
        </span>
        <h2 className="mb-2 text-xl font-bold leading-tight text-slate-50">{job.title}</h2>
        <p className="mb-5 text-sm text-slate-300">{valueOrFallback(job.groupName, "Group not specified")}</p>
      </div>

      <div className="grid gap-3 text-sm text-slate-300">
        <div className="flex items-center">
          <MapPin className="mr-2 text-cyan-200" size={16} />
          <span>{formatJobLocation(job)}</span>
        </div>
        <div className="flex items-center">
          <Calendar className="mr-2 text-amber-200" size={16} />
          <span>Posted {formatJobDate(job.createdOn)}</span>
        </div>
      </div>

      <div className="mt-auto pt-5">
        <div className="mb-4 rounded-xl border border-slate-500/20 bg-slate-950/30 p-3">
          <BTCConverter value={job.weeklyCompensation} fontType="Arial" fontSize="16px" height="50px" />
        </div>
        <span
          className={`tyk-action w-full ${hasApplied ? "border-green-300/40 bg-green-500/20 text-green-100" : ""}`}
        >
          {hasApplied ? "Applied" : "View details"}
        </span>
      </div>
    </button>
  )
}

